import { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface RemoveUserMessageDialogProps {
    open: boolean;
    user: string;
    onAcceptEvent: () => void;
    onDismiss: () => void;
}

const RemoveUserMessageDialog: FC<RemoveUserMessageDialogProps> = ({
    open,
    onAcceptEvent,
    onDismiss,
    user,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>{t('Remove message')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography>
                        {t('Are you sure you want to remove this message sent by {{username}}?', {
                            username: user,
                        })}
                    </Typography>
                    <Typography>
                        {t(
                            'The message will disappear from all the sessions connected. This action can not be reverted.',
                        )}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onAcceptEvent}>{t('Remove it')}</Button>
                <Button onClick={onDismiss} autoFocus>
                    {t('Cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RemoveUserMessageDialog;
